module.exports = __webpack_public_path__ + "static/media/biaoge_022.ad2047cb.png";